<template>
  <b-container style="padding: 2rem 0rem;">
    <div class="loading">登錄資料檢查…</div>
  </b-container>
</template>

<script>
import Vue from 'vue'
import * as tools from '../tool'
export default {
  name: 'vhome',
  data () {
    return {
      isIE: false,
      memberShow:false,
      inputData: null,
    }
  },
  computed: {
    debugMode () {
      return this.$store.getters.getDebugFg;
    },
  },
  methods: {
  },
  created () {
    if (this.debugMode) {
      console.log('======created HomeView =====');
    }
    var vm = this;
    var userAgent = navigator.vendor;
    this.isIE = navigator.userAgent.indexOf("MSIE ") > -1 || navigator.userAgent.indexOf("Trident/") > -1;
    this.isSidebarOpen = true;
    var obj = {
      text1 : this.$route.query.sessionId,
      text2 : this.$route.query.cn
    };
    this.$http.put('./WebApi/Common/Verify', obj)
              .then((response) => {
                var tmpData = response.data
                 // vm.usrData = tmpData
                  vm.inputData = tmpData
                  // vm.$store.dispatch('actionLogin', vm.usrData)
                  // vm.$router.push({ path: 'StdLogin' })

                  vm.memberShow = true;

            this.$store.dispatch("actionLogin2", vm.memberShow);
            this.$store.dispatch("actionLogin2Data", vm.inputData);
            vm.$router.push({ path: "StdLogin" });

              })
              .catch(function (error) {
                tools.showAlert(vm, 'danger', '對不起參數錯誤無法登入!!!');
                vm.$router.push({ path: '/' })
              })
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>

</style>
